import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import SimpleTopicManager from 'managers/simpleTopic';
import CommentsFilters from 'models/commentsFilters';
import { TopicsService } from 'services/topics';
import './clearToDoButton.html';

export interface ActivityClearToDoButtonConfig {
    topicId: SubscribableOrNullableValue<string>
    commentsFilters: SubscribableOrNullableValue<CommentsFilters>
}

@injectable()
export default class ActivityClearToDoButton {
    private topicId: Subscribable<string | undefined>

    labels = labels

    toDoCount: Subscribable<number>

    isBusy = ko.observable(false);
    canClear: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: ActivityClearToDoButtonConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.topicsService) private topicsService: TopicsService,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        this.topicId = ko.flattenComputed(config.topicId);

        const filters = ko.flattenComputed(config.commentsFilters);
        const searchString = filters.pluck(f => f.searchString, '');
        const peopleTagsIDs = filters.pluck(f => f.peopleTagsIDs, []);

        const topicManager = storage.get(SimpleTopicManager, { topicId: this.topicId, searchString, peopleTagsIDs });
        const topic = topicManager.pluck(m => m.topic);
        this.toDoCount = topic.pluck(m => m.toDoCount, 0);
        const hasToDo = ko.pureComputed(() => this.toDoCount() > 0);

        const isBusy = ko.observable(false);
        this.canClear = ko.pureComputed(() => hasToDo() && !isBusy());

        const isReady = ko.pureComputed(() => topic() != undefined);

        ko.applyBindingsToNode(info.element, {
            'visible': isReady,

            'css': {
                'task-activity__clear-todo-button': true
            }
        });
    }

    clear = () => {
        if (this.isBusy()) return;

        const topicId = this.topicId();

        if (topicId != undefined) {
            system.confirm(messages.AreYouSureYouWantToMarkAllAsRead, async () => {
                this.isBusy(true);

                try {
                    await this.topicsService.markAllCommentsAsRead(topicId)
                } catch (ex) {
                    system.handleError(ex);
                } finally {
                    this.isBusy(false);
                }
            });
        }
    }
}